module.exports = __webpack_public_path__ + "dcabd6fd4efca8c155f949e3602e2dae.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/nature/Desert1.jpg
// module id = 3355
// module chunks = 0